import React, { Component } from 'react'
import clientParameters from './ClientParameters'
import AppConfig from "../AppConfig";

class Header extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isCheckout: props.isCheckout,
        }
    }

    render() {
        const { isCheckout } = this.state

        const parameters = clientParameters.data

        const headerImageUrl = isCheckout ? parameters.app_checkout_header || parameters.app_header_image : parameters.app_header_image

        const checkoutImageUrl = isCheckout ? parameters.app_checkout_image || null : null

        let headerContainerStyles = {
            // height: parameters.header_image_block_height ? parameters.header_image_block_height + 'px' : 'auto',
            // alignItems: parameters.header_image_alignment ?? "center",
        }

        return (
            <>
                <div
                    className="row justify-content-center survey-header"
                    style={headerContainerStyles}
                >
                    <div className="col p-0">
                        {headerImageUrl && (
                            <div
                                className="ratio-21x9"
                                style={{
                                    objectFit: 'cover',
                                    // maxHeight: 200,
                                    overflow: 'hidden',
                                    position: 'relative',
                                    textAlign: 'center'
                                }}
                            >
                                <img src={AppConfig.resourceBaseUrl + headerImageUrl} className="img-fluid" alt="" />

                                {checkoutImageUrl && (
                                    <>
                                        <br />
                                        <img src={AppConfig.resourceBaseUrl + checkoutImageUrl} className="img-fluid w-100" alt="" />
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <br />
            </>
        )
    }
}

export default Header
